import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			menu: {
				"&:hover": {
					boxShadow: "none",
					background: "none"
				}
			},
			label: {
				display: "flex",
				flexDirection: "column",
				fontSize: 12,
				textTransform: "none"
			},
			iconActive: {
				width: 46,
				height: 40,
				background: theme.palette.common.white,
				padding: "6px 0px 0px 0px",
				marginTop: "-10px",
				borderRadius: 29,
				boxShadow: "-1px -5px 5px -0px rgb(0 0 0 / 5%)"
			},
			icNonActive: {
				width: 30,
				height: 30
			},
			menuTitle: {
				color: theme.palette.primary.main
			},
			colorActive: {
				color: theme.palette.primary.main
			},
			color: {
				color: theme.palette.primary.contrastText
			}
		}),
	{
		name: "FooterPage",
		index: 1
	}
);

export default useStyles;
